export function PolicyIcon() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.35647 8.27453C7.47635 8.17969 7.63302 8.14491 7.78177 8.1801L12 9.17793L16.2182 8.1801C16.367 8.14491 16.5237 8.17969 16.6435 8.27453C16.7634 8.36936 16.8333 8.51381 16.8333 8.66667V14.8584C16.8333 15.0423 16.7323 15.2114 16.5704 15.2986L12.2371 17.632C12.0891 17.7117 11.9109 17.7117 11.7629 17.632L7.42962 15.2986C7.26766 15.2114 7.16667 15.0423 7.16667 14.8584V8.66667C7.16667 8.51381 7.23658 8.36936 7.35647 8.27453ZM8.16667 9.29874V14.5598L11.4969 16.353V10.0865L8.16667 9.29874ZM12.4969 10.088V16.3563L15.8333 14.5598V9.29874L12.4969 10.088Z"
        fill="#4ADE80"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.6997 3.10022C11.8776 2.96659 12.1224 2.96659 12.3003 3.10022L14.0171 4.38978C15.3658 5.40285 17.0706 5.81922 18.7345 5.54191L19.9178 5.34469C20.0628 5.32053 20.211 5.36138 20.3232 5.45638C20.4353 5.55138 20.5 5.69091 20.5 5.83789V12.1721C20.5 15.0784 18.9256 17.2903 17.1181 18.756C16.2131 19.4899 15.2388 20.0468 14.3473 20.4215C13.4655 20.7923 12.6282 21 12 21C11.3727 21 10.5359 20.7947 9.65377 20.4264C8.76226 20.0541 7.78769 19.5001 6.88241 18.768C5.07384 17.3054 3.5 15.0933 3.5 12.1721V5.83794C3.5 5.69097 3.56467 5.55138 3.67681 5.45638C3.78896 5.36137 3.93722 5.32053 4.0822 5.34469L5.26551 5.54191C6.92936 5.81922 8.63419 5.40285 9.98289 4.38978L11.6997 3.10022ZM4.5 6.42812V12.1721C4.5 14.6995 5.85525 16.6513 7.51122 17.9905C8.33821 18.6593 9.22978 19.1657 10.0391 19.5036C10.8577 19.8454 11.5564 20 12 20C12.4427 20 13.1409 19.844 13.9598 19.4997C14.7692 19.1595 15.661 18.6502 16.4882 17.9793C18.1453 16.6355 19.5 14.6835 19.5 12.1721V6.42812L18.8989 6.5283C16.9652 6.85058 14.9839 6.36669 13.4165 5.18935L12 4.12534L10.5835 5.18935C9.01606 6.36669 7.03478 6.85058 5.10111 6.5283L4.5 6.42812Z"
        fill="white"
      />
    </svg>
  );
}
